import styled from "styled-components";

export const SwitcherWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.125rem;
`;

export const Sep = styled.span`
  color: var(--rule);
  font-size: 0.875rem;
`;

export const LangBtn = styled.button<{ $active: boolean }>`
  min-width: 32px;
  min-height: 36px;
  padding: 0 0.25rem;
  background: none;
  border: 0;
  cursor: pointer;
  font-size: 0.8125rem;
  font-weight: ${({ $active }) => ($active ? 600 : 400)};
  letter-spacing: 0.04em;
  color: ${({ $active }) => ($active ? "var(--ink)" : "var(--text-muted)")};
  text-decoration: ${({ $active }) => ($active ? "underline" : "none")};
  text-decoration-color: var(--ledger);
  text-underline-offset: 6px;
  text-decoration-thickness: 1px;

  &:hover { color: var(--ink); }
`;
